(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blissy-club-cart-offer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    var button = event.target.closest && event.target.closest('[data-club-join]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    var error = button.closest('.blissy-club-offer').querySelector('[data-club-error]');
    button.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;
    var items = [{ id: Number(button.dataset.clubVariant), quantity: 1, selling_plan: Number(button.dataset.clubPlan) }];
    var rebuyCart = window.Rebuy && Rebuy.Cart;
    var add = rebuyCart && rebuyCart.addItem
      ? new Promise(function(resolve, reject) { rebuyCart.addItem({ items: items }, { success: resolve, error: reject }); })
      : fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items })
        }).then(function(response) {
          if (!response.ok) throw new Error('Unable to add Blissy Club');
          if (rebuyCart && rebuyCart.fetchCart) rebuyCart.fetchCart();
        });
    add.then(function() {
      button.removeAttribute('aria-busy');
    }).catch(function() {
      button.removeAttribute('aria-busy');
      if (error) error.hidden = false;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blissy-help-ui"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blissy-help-center')) {
    customElements.define('blissy-help-center', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.categories = [...this.querySelectorAll('.blissy-help__category')];
        this.links = [...this.querySelectorAll('[data-help-category]')];
        this.items = [...this.querySelectorAll('details')].map(element => ({
          element,
          category: element.closest('.blissy-help__category'),
          question: this.normalize(element.querySelector('summary').textContent),
          text: this.normalize(element.textContent)
        }));
        this.activeCategory = 'faq';
        this.bindSearch();
        document.addEventListener('shopify:section:load', () => this.bindSearch(), { signal });
        document.addEventListener('click', event => {
          const link = event.target.closest('[data-help-category],[data-help-jump]');
          if (!link) return;
          const target = this.querySelector(link.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          this.showTarget(target);
          history.pushState(null, '', link.getAttribute('href'));
          if (link.hasAttribute('data-help-jump') || matchMedia('(max-width:767px)').matches) {
            (target.matches('details') ? target : this.querySelector('.blissy-help__results')).scrollIntoView({ behavior: 'instant', block: 'start' });
          }
        }, { signal });
        window.addEventListener('hashchange', () => this.openHash(), { signal });
        this.querySelectorAll('[data-help-clear]').forEach(button => button.addEventListener('click', () => this.clearSearch(), { signal }));
        this.openHash();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.searchController?.abort();
        this.controller = null;
      }
      normalize(value) {
        return value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
      }
      bindSearch() {
        this.searchController?.abort();
        this.searchController = new AbortController();
        const signal = this.searchController.signal;
        this.form = document.querySelector('[data-help-search]');
        if (!this.form) return;
        this.input = this.form.querySelector('input');
        this.form.hidden = false;
        this.input.addEventListener('input', () => this.filter(), { signal });
        this.form.addEventListener('submit', event => {
          event.preventDefault();
          this.filter();
          const results = this.querySelector('.blissy-help__results');
          results.scrollIntoView({ behavior: 'instant', block: 'start' });
          results.focus({ preventScroll: true });
        }, { signal });
        this.form.querySelector('[data-help-clear]').addEventListener('click', () => this.clearSearch(), { signal });
      }
      openHash() {
        const id = decodeURIComponent(location.hash.slice(1));
        this.showTarget(this.querySelector('[id="' + CSS.escape(id) + '"]') || this.categories[0]);
      }
      showTarget(target) {
        this.activeCategory = target.closest('.blissy-help__category').id;
        if (this.input) this.input.value = '';
        this.filter();
        if (target.matches('details')) target.open = true;
      }
      clearSearch() {
        if (this.input) this.input.value = '';
        this.filter();
        this.input?.focus();
      }
      filter() {
        const query = this.normalize(this.input?.value || '');
        const words = query.split(' ').filter(Boolean);
        const seen = new Set();
        let count = 0;
        this.classList.toggle('is-searching', !!query);
        this.items.forEach(item => {
          let visible = query ? words.every(word => item.text.includes(word)) : item.category.id === this.activeCategory;
          if (query && visible) {
            if (seen.has(item.question)) visible = false;
            else seen.add(item.question);
          }
          item.element.hidden = !visible;
          if (visible) count++;
        });
        this.categories.forEach(category => { category.hidden = !this.items.some(item => item.category === category && !item.element.hidden); });
        this.links.forEach(link => {
          if (!query && link.dataset.helpCategory === this.activeCategory) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        this.querySelector('.blissy-help__search-heading').hidden = !query;
        this.querySelector('[data-help-status]').textContent = count + ' ' + (count === 1 ? this.dataset.resultOne : this.dataset.resultMany);
        this.querySelector('.blissy-help__empty').hidden = !query || count > 0;
        if (this.form) this.form.querySelector('[data-help-clear]').hidden = !query;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blissy-reviews-page"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blissy-review-page')) {
    customElements.define('blissy-review-page',class extends HTMLElement {
      connectedCallback() {
        if (this.observer) return;
        const widget = this.querySelector('#stamped-reviews-widget');
        if (!widget) return;
        const sync = () => {
          const set = (element,name,value) => { if(element.getAttribute(name)!==value) element.setAttribute(name,value); };
          this.querySelector('.blissy-reviews-page__loading').hidden = !!widget.querySelector('.stamped-review-card');
          const count = widget.querySelector('.stamped-widget-text');
          if (count && /^\d+$/.test(count.textContent.trim())) count.textContent=this.dataset.countLabel.replace('[count]',Number(count.textContent.trim()).toLocaleString(document.documentElement.lang || 'en'));
          const stars = widget.querySelector('.stamped-widget-stars[data-rating]');
          if (stars) set(stars,'aria-label',this.dataset.ratingLabel.replace('[rating]',stars.dataset.rating));
          widget.querySelectorAll('.btn-product-reviews,.btn-site-reviews').forEach(tab=>{
            const label=tab.matches('.btn-product-reviews')?this.dataset.productLabel:this.dataset.siteLabel;
            if(tab.textContent!==label) tab.textContent=label;
            set(tab,'role','button');set(tab,'tabindex','0');set(tab,'aria-pressed',String(tab.parentElement.classList.contains('active')));
          });
          widget.querySelectorAll('.read-more').forEach(control=>{set(control,'role','button');set(control,'tabindex','0');set(control,'aria-label',this.dataset.moreLabel);});
          const pagination = widget.querySelector('.stamped-pagination');
          if (pagination) { set(pagination,'role','navigation');set(pagination,'aria-label',this.dataset.paginationLabel); }
          widget.querySelectorAll('.stamped-pagination a').forEach(control=>{
            const label=control.closest('#stamped-pagination-prev')?this.dataset.previousLabel:control.closest('#stamped-pagination-next')?this.dataset.nextLabel:this.dataset.pageLabel.replace('[number]',control.dataset.page);
            set(control,'role','button');set(control,'tabindex','0');set(control,'aria-label',label);
            if (control.closest('.is-active')) set(control,'aria-current','page');
          });
        };
        this.onKey = event => {
          if (!['Enter',' '].includes(event.key)) return;
          const control=event.target.closest('a[role="button"]');
          if (!control || !this.contains(control)) return;
          event.preventDefault();control.click();
        };
        this.addEventListener('keydown',this.onKey);
        this.observer=new MutationObserver(sync);
        this.observer.observe(widget,{childList:true,subtree:true});
        sync();
      }
      disconnectedCallback() { this.observer?.disconnect();this.observer=null;this.removeEventListener('keydown',this.onKey); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blissy-support-page"] && !Shopify.designMode) return;
  try {
    const supportForm = document.getElementById('support-form');
  if (supportForm) {
    const labelFrame = () => supportForm.querySelectorAll('iframe').forEach(frame => {
      frame.title = document.getElementById('support-form-heading').textContent.trim();
    });
    new MutationObserver(labelFrame).observe(supportForm, {childList:true, subtree:true});
    labelFrame();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blissy-collection-filters')) {
    customElements.define('blissy-collection-filters', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('change', event => {
          const type = event.target.matches('[data-collection-type]');
          if (!type && !event.target.matches('[data-collection-sort]')) return;
          const url = new URL(window.location.href);
          if (type) {
            url.pathname = this.dataset.collectionUrl;
            url.searchParams.delete('filter.p.m.c_custom.c_type');
            url.searchParams.delete('filter.p.product_type');
            if (event.target.value) url.searchParams.set(event.target.dataset.filterParam,event.target.value);
          } else {
            url.searchParams.set('sort_by',event.target.value);
          }
          url.searchParams.delete('page');
          window.location.assign(url.href);
        });
        const type = this.querySelector('[data-collection-type]');
        const active = new URL(window.location.href).searchParams.get(type.dataset.filterParam);
        if (active && [...type.options].some(option => option.value === active)) type.value = active;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-style-navigation"] && !Shopify.designMode) return;
  try {
    function revealCollectionStyle(root) {
    root.querySelectorAll('.collection-styles__track').forEach(track => {
      const current = track.querySelector('[aria-current]');
      if (current) track.scrollLeft = current.offsetLeft - track.firstElementChild.offsetLeft;
    });
  }
  requestAnimationFrame(() => revealCollectionStyle(document));
  document.addEventListener('shopify:section:load', event => revealCollectionStyle(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hair-accessory-video-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blissy-accessory-video-dialog')) {
    customElements.define('blissy-accessory-video-dialog', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.playerHost = this.querySelector('[data-hair-video-player]');
        document.addEventListener('click', event => {
          const trigger = event.target.closest('[data-hair-video-open]');
          if (!trigger) return;
          const component = trigger.closest('blissy-story-video');
          const wistiaId = component?.dataset.videoId;
          let player;
          let ratio = Number(component?.dataset.videoRatio) || 16 / 9;
          if (wistiaId && /^[a-z0-9]{10}$/i.test(wistiaId)) {
            player = document.createElement('iframe');
            player.src = `https://fast.wistia.net/embed/iframe/${wistiaId}?autoPlay=true&videoFoam=true&playerColor=29376e`;
          } else {
            const mediaId = trigger.dataset.hairMediaId;
            const item = mediaId && document.querySelector(`[data-hair-media="${CSS.escape(mediaId)}"]`);
            const source = item?.querySelector('video,iframe');
            if (!source) return;
            player = source.cloneNode(true);
            player.removeAttribute('id');
            ratio = Number(getComputedStyle(item).getPropertyValue('--video-ratio')) || ratio;
            if (player.tagName === 'IFRAME') {
              const url = new URL(player.src, location.href);
              url.searchParams.set('autoplay', '1');
              player.src = url.href;
            } else {
              player.autoplay = true;
              player.controls = true;
              player.preload = 'auto';
            }
          }
          event.preventDefault();
          document.querySelectorAll('.hair-videos video').forEach(video => video.pause());
          document.querySelectorAll('.hair-videos blissy-story-video[data-inline-player]').forEach(video => {
            video.querySelector('iframe')?.remove();
            const preview = video.querySelector('[data-story-video]');
            if (preview) preview.hidden = false;
          });
          this.opener = trigger;
          player.title = trigger.dataset.videoTitle || this.dialog.getAttribute('aria-label');
          if (player.tagName === 'IFRAME') {
            player.allow = 'autoplay; fullscreen; picture-in-picture';
            player.allowFullscreen = true;
          }
          this.dialog.style.setProperty('--video-ratio', ratio > .2 && ratio < 5 ? ratio : 16 / 9);
          this.playerHost.replaceChildren(player);
          this.dialog.showModal();
          if (player.tagName === 'VIDEO') player.play().catch(() => {});
        }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target === this.dialog || event.target.closest('[data-hair-video-close]')) this.dialog.close();
        }, options);
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.dialog.open) {
            event.preventDefault();
            event.stopPropagation();
            this.dialog.close();
          }
        }, { ...options, capture: true });
        this.dialog.addEventListener('close', () => {
          this.playerHost.replaceChildren();
          this.opener?.focus({ preventScroll: true });
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.dialog?.close();
        this.playerHost?.replaceChildren();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hair-care-style-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blissy-brush-navigation')) {
    customElements.define('blissy-brush-navigation', class extends HTMLElement {
      connectedCallback() {
        const selector = document.querySelector('.pdp-hair-care #blissy-type-selector');
        if (!selector || this.observer) return;
        const update = () => {
          const label = selector.querySelector('.blissy-label');
          if (label && label.textContent !== this.dataset.exploreLabel) label.textContent = this.dataset.exploreLabel;
        };
        update();
        this.observer = new MutationObserver(update);
        this.observer.observe(selector, {childList:true,subtree:true});
      }
      disconnectedCallback() { this.observer?.disconnect(); this.observer = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blissy-header-search')) {
    customElements.define('blissy-header-search', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-quick-open]');
        this.input = this.querySelector('input[type=search]');
        this.updateViewport = () => {
          const height = window.visualViewport?.height || window.innerHeight;
          this.dialog.style.setProperty('--quick-viewport-height', `${height}px`);
          this.dialog.classList.toggle('is-compact', height <= 600);
        };
        window.visualViewport?.addEventListener('resize', this.updateViewport);
        this.trigger.addEventListener('click', () => {
          this.previousOverflow = document.body.style.overflow;
          this.updateViewport();
          this.dialog.showModal();
          document.body.style.overflow = 'hidden';
          this.trigger.setAttribute('aria-expanded', 'true');
          this.input.focus({preventScroll:true});
          this.querySelector('predictive-search')?.onFocus?.();
        });
        this.querySelector('[data-quick-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            this.dialog.close();
          }
        });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          document.body.style.overflow = this.previousOverflow;
          this.trigger.setAttribute('aria-expanded', 'false');
          this.querySelector('predictive-search')?.close?.();
          this.trigger.focus({preventScroll:true});
        });
        if (!this.querySelector('predictive-search')) {
          const clear = this.querySelector('[type=reset]');
          this.input.addEventListener('input', () => clear.classList.toggle('hidden', !this.input.value));
          this.querySelector('form').addEventListener('reset', event => { event.preventDefault(); this.input.value=''; clear.classList.add('hidden'); this.input.focus(); });
        }
      }
      disconnectedCallback() {
        window.visualViewport?.removeEventListener('resize', this.updateViewport);
        if (this.dialog?.open) this.dialog.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["local-preview-navigation"] && !Shopify.designMode) return;
  try {
    if (['127.0.0.1', 'localhost', '[::1]'].includes(window.location.hostname)) {
    if (location.port && !window.blissyLocalProductRequests) {
      window.blissyLocalProductRequests = true;
      const originalOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function(method, resource, ...options) {
        let target = resource;
        try {
          const url = new URL(resource, location.href);
          if (String(method).toUpperCase() === 'GET' && url.hostname === location.hostname && !url.port && /^\/products\/[^/]+\.(?:js|json)$/.test(url.pathname)) {
            target = location.origin + url.pathname + url.search;
          }
        } catch {}
        return originalOpen.call(this, method, target, ...options);
      };
    }
    const storefrontHosts = new Set(['blissy.com', 'www.blissy.com', 'blissy-brand.myshopify.com']);
    const localizeLink = (link) => {
      const href = link.getAttribute('href');
      if (!href || /^(?:#|mailto:|tel:|javascript:)/i.test(href)) return;
      let url;
      try { url = new URL(href, window.location.href); } catch { return; }
      if ((url.origin === window.location.origin || storefrontHosts.has(url.hostname)) && /^\/account(?:\/|$)/.test(url.pathname)) {
        const accountUrl = `https://blissy.com${url.pathname}${url.search}${url.hash}`;
        if (href !== accountUrl) link.setAttribute('href', accountUrl);
        return;
      }
      if (!/^(https?:)?\/\//i.test(href)) return;
      if (!storefrontHosts.has(url.hostname)) return;
      if (/^\/(?:checkout|checkouts|cdn|apps|tools)(?:\/|$)/.test(url.pathname)) return;
      link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
    };
    const scan = (root) => {
      if (root.matches?.('a[href]')) localizeLink(root);
      root.querySelectorAll?.('a[href]').forEach(localizeLink);
    };
    scan(document);
    new MutationObserver((records) => {
      records.forEach((record) => {
        if (record.type === 'attributes') localizeLink(record.target);
        else record.addedNodes.forEach(scan);
      });
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-cta-savings"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blissy-cta-savings')) {
    customElements.define('blissy-cta-savings',class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected || this.controller) return;
          const root = this.closest('.pdp-refresh');
          const button = this.closest('[data-add-to-cart]');
          const form = button?.closest('form');
          if (!root || !form) return;
          this.controller = new AbortController();
          const options = {signal:this.controller.signal};
          const subscription = form.querySelector('.loop-subscription-container');
          let subscriptionProduct;
          try { subscriptionProduct = JSON.parse(form.querySelector('script[class^="loopProductQuickJson-"]')?.textContent || 'null'); } catch (_) {}
          const display = percent => {
            const visible = Number.isFinite(percent) && percent>0 && percent<=100;
            const text = visible ? `${this.dataset.saveLabel} ${percent}%` : '';
            if (this.textContent !== text) this.textContent = text;
            this.hidden = !visible;
            button.classList.toggle('has-cta-savings',visible);
          };
          const update = () => {
            if (document.getElementById('blissy-cross-sell')?.dataset.selected === 'true') { display(0); return; }
            const variantId = Number(form.querySelector('[name="id"]')?.value);
            const variant = subscriptionProduct?.variants?.find(item => item.id === variantId);
            const price = Number(variant?.price ?? this.dataset.price);
            const reference = Math.max(price,Number(variant?.compare_at_price ?? this.dataset.comparePrice) || 0);
            if (!Number.isFinite(reference) || reference<=0) { display(0); return; }
            const quantity = Math.max(1,Math.floor(Number(form.querySelector('[data-quantity-input]')?.value) || 1));
            const pricing = root.blissyPurchasePricing;
            const ratio = pricing?.basePriceInCents>0 && Number.isFinite(pricing.unitPriceInCents) ? pricing.unitPriceInCents/pricing.basePriceInCents : 1;
            if (!Number.isFinite(ratio) || ratio<0 || ratio>1) { display(0); return; }
            let unit = Math.round(price*ratio);
            let total = unit*quantity;
            const plan = form.querySelector('[name="selling_plan"]')?.value;
            if (plan) {
              const allocation = variant?.selling_plan_allocations?.find(item => String(item.selling_plan_id) === plan);
              if (!allocation || price<=0 || !Number.isFinite(allocation.price)) { display(0); return; }
              unit = Math.round(unit*allocation.price/price);
              total = unit*quantity;
            } else {
              const bundle = root.querySelector('.pdp-hero__bundle');
              const bundleQuantity = Number(bundle?.dataset.bundleQuantity);
              if (pricing && bundleQuantity>=2 && Number.isFinite(pricing.bundleTotalInCents) && pricing.basePriceInCents>0) {
                const bundles = Math.floor(quantity/bundleQuantity);
                total = bundles*Math.round(pricing.bundleTotalInCents*price/pricing.basePriceInCents)+(quantity-bundles*bundleQuantity)*unit;
              }
            }
            display(Math.round((1-total/(reference*quantity))*100));
          };
          root.addEventListener('blissy:purchase-pricing',update,options);
          form.addEventListener('input',() => queueMicrotask(update),options);
          form.addEventListener('change',() => queueMicrotask(update),options);
          document.addEventListener('blissy:cross-sell-changed',update,options);
          if (subscription) {
            this.observer = new MutationObserver(update);
            this.observer.observe(subscription,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','style','value']});
          }
          update();
        });
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-product-instructions"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blissy-product-instructions')) {
    customElements.define('blissy-product-instructions', class extends HTMLElement {
      connectedCallback() {
        this.update = () => this.showInstructions();
        queueMicrotask(this.update);
        document.addEventListener('shopify:section:load', this.update);
      }
      showInstructions() {
        const source = document.querySelector('#mask-details .product-description > div');
        const output = this.querySelector('[data-product-instructions-output]');
        if (!source || !output) return;
        const nodes = [...source.children];
        const start = nodes.findIndex(node => /^how to use\s*:/i.test(node.textContent.trim()));
        if (start < 0) return;
        const instructions = [];
        for (const node of nodes.slice(start)) {
          const text = node.textContent.trim();
          if (/^(comes in\b|your cool.down\b)/i.test(text)) break;
          if (/^(SCRIPT|STYLE|META)$/.test(node.tagName)) continue;
          if (/^how to use\s*:\s*$/i.test(text)) continue;
          const clone = node.cloneNode(true);
          clone.removeAttribute('id');
          clone.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
          instructions.push(clone);
          // Chill Edition provides its full instructions in the heading paragraph.
          if (/^how to use\s*:/i.test(text) && text.length > 60) break;
        }
        if (instructions.length) {
          output.replaceChildren(...(this.hasAttribute('data-therapy-cards') ? this.groupTherapies(instructions) : instructions));
        }
      }
      groupTherapies(instructions) {
        const headingPattern = /^\s*For (Heat|Cold) Therapy\b\s*:?\s*/i;
        // Only group recognized source headings; unfamiliar content retains its original layout.
        if (!['heat', 'cold'].every(type => instructions.some(node => node.textContent.match(headingPattern)?.[1].toLowerCase() === type))) return instructions;
        const groups = [];
        let group;
        for (const node of instructions) {
          const match = node.textContent.match(headingPattern);
          if (match) {
            group = document.createElement('div');
            group.className = 'mask-instructions__therapy mask-instructions__therapy--' + match[1].toLowerCase();
            const heading = document.createElement('h4');
            heading.textContent = match[0].trim();
            group.append(heading);
            groups.push(group);
            // A heading may share a paragraph with instructions. Move only its text,
            // preserving every instruction, emphasis, and product-specific timing.
            const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
            let remaining = match[0].length;
            while (remaining > 0 && walker.nextNode()) {
              const text = walker.currentNode;
              const count = Math.min(remaining, text.textContent.length);
              text.textContent = text.textContent.slice(count);
              remaining -= count;
            }
          }
          if (node.textContent.trim()) {
            if (group) group.append(node);
            else groups.push(node);
          }
        }
        return groups;
      }
      disconnectedCallback() { document.removeEventListener('shopify:section:load', this.update); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-product-selectors"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.pdp-refresh #blissy-scent-selector').forEach(selector => {
    const markCurrent = () => selector.querySelectorAll('.scent-card').forEach(card => {
      if (card.classList.contains('active')) card.setAttribute('aria-current', 'page');
      else card.removeAttribute('aria-current');
    });
    markCurrent();
    new MutationObserver(markCurrent).observe(selector, {childList:true,subtree:true});
  });
  document.querySelectorAll('.pdp-pillow #blissy-size-selector').forEach(selector => {
    const size = document.querySelector('.pdp-pillow #blissy-selectors')?.dataset.cSize;
    const updateShapeLinks = () => selector.querySelectorAll('.pillow-shape-btn').forEach(link => {
      const url = new URL(link.href, location.href);
      if (size === 'queen' || size === 'king') {
        url.pathname = url.pathname.replace(/-(queen|king)$/, '-' + size);
        link.setAttribute('href', url.pathname + url.search + url.hash);
      }
      if (link.classList.contains('active')) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
    updateShapeLinks();
    new MutationObserver(updateShapeLinks).observe(selector, {childList:true,subtree:true});
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-product-ui"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blissy-pillowcase-quantity')) {
    customElements.define('blissy-pillowcase-quantity', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const input = this.querySelector('input');
        const decrease = this.querySelector('[data-quantity-decrease]');
        const increase = this.querySelector('[data-quantity-increase]');
        const update = () => {
          decrease.disabled = !input.value || Number(input.value) <= Number(input.min || 1);
          increase.disabled = !!input.max && Number(input.value) >= Number(input.max);
        };
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button || button.disabled) return;
          if (button === decrease) input.stepDown();
          else if (button === increase) input.stepUp();
          else return;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
          update();
        }, options);
        input.addEventListener('input', update, options);
        input.addEventListener('change', update, options);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-pdp-reviews]')) return;
    const tab = document.querySelector('.pdp-refresh #reviews-tab-button');
    if (tab) { event.preventDefault(); tab.click(); }
  });
  if (!customElements.get('blissy-pillowcase-buybar')) {
    customElements.define('blissy-pillowcase-buybar', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected || this.controller) return;
          const root = this.closest('.pdp-refresh');
          const primary = root?.querySelector('[data-add-to-cart]');
          if (!primary) return;
          this.controller = new AbortController();
          const button = this.querySelector('button');
          const price = this.querySelector('[data-pdp-current-price]');
          const savings = this.querySelector('[data-pdp-savings]');
          const each = this.querySelector('[data-pdp-each]');
          const quantityDisplay = this.querySelector('[data-pdp-quantity]');
          const quantity = root.querySelector('[data-quantity-input]');
          const offers = root.querySelector('.pdp-hero__offers');
          const form = primary.closest('form');
          const subscription = form?.querySelector('.loop-subscription-container');
          const planLabel = this.querySelector('[data-pdp-plan]');
          const updatePosition = () => {
            const rect = primary.getBoundingClientRect();
            this.hidden = rect.top < innerHeight && rect.bottom > 0;
            this.chooseOptions = rect.top >= innerHeight;
            button.textContent = this.chooseOptions ? this.dataset.optionsLabel : primary.querySelector('.addtocarttext').textContent;
            button.disabled = primary.disabled;
          };
          const update = () => {
            updatePosition();
            quantityDisplay.textContent = `${quantity?.value || 1} ×`;
            const sale = [...offers.querySelectorAll('.additional-sale-box .total-discount-price')].find(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
            const bundlePrice = offers.querySelector('.pdp-hero__bundle .bogoeach');
            const bundleDiscount = offers.querySelector('.pdp-hero__bundle .bogosave');
            const bundleQuantity = Number(offers.querySelector('.pdp-hero__bundle')?.dataset.bundleQuantity || 4);
            const bundleSelected = Number(quantity?.value) === bundleQuantity && !!bundlePrice && !!bundleDiscount;
            const currentPrice = bundleSelected ? bundlePrice : sale || offers.querySelector('[data-product-price]');
            price.textContent = currentPrice?.textContent.trim() || '';
            each.hidden = Number(quantity?.value) <= 1;
            const discountLabel = bundleSelected ? bundleDiscount : sale ? sale.closest('.additional-sale-box')?.querySelector('.discount-amount') : offers.querySelector('.special-sale-product__discount');
            const percentText = discountLabel?.textContent.match(/\d+(?:[.,]\d+)?/)?.[0] || '';
            const savedPercent = Number(percentText.replace(',', '.'));
            const hasSavings = savedPercent > 0 && savedPercent <= 100;
            savings.hidden = !hasSavings;
            savings.textContent = hasSavings ? `${this.dataset.savingsLabel} ${percentText}%` : '';
            if (subscription?.getClientRects().length) {
              const selectedPlan = form.querySelector('[name="selling_plan"]')?.value;
              const group = subscription.querySelector('.loop-subscription-group-radio:checked')?.closest('.loop-subscription-group');
              const widgetPrice = selectedPlan && group ? group.querySelector('.loop-subscription-group-price-amount') : subscription.querySelector('.loop-one-time-purchase-option-price-amount');
              const widgetText = widgetPrice?.textContent.trim();
              // Existing campaign code can briefly show loading dots; keep the last confirmed price then.
              if (widgetText && /\d/.test(widgetText)) {
                this.confirmedPlanPrice = widgetText;
                price.textContent = widgetText;
              } else if (this.confirmedPlanPrice) price.textContent = this.confirmedPlanPrice;
              if (selectedPlan && group) {
                const badge = group.querySelector('.loop-subscription-group-discount-badge');
                savings.hidden = !badge?.getClientRects().length;
                savings.textContent = badge?.textContent.trim() || '';
              }
              if (planLabel) {
                planLabel.hidden = !selectedPlan;
                planLabel.textContent = selectedPlan ? group?.querySelector('.loop-selling-plan-selector')?.selectedOptions[0]?.textContent.trim() || '' : '';
              }
            }

          };
          button.addEventListener('click', () => {
            if (this.chooseOptions) (subscription?.getClientRects().length ? subscription : root.querySelector('.selectors')).scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
            else primary.click();
          }, { signal: this.controller.signal });
          this.intersection = new IntersectionObserver(update);
          this.intersection.observe(primary);
          this.mutations = new MutationObserver(update);
          this.mutations.observe(offers, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'style', 'class'] });
          this.mutations.observe(primary, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
          if (subscription) {
            this.mutations.observe(form, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'style', 'data-selling-plan-id'] });
            form.addEventListener('change', () => queueMicrotask(update), { signal: this.controller.signal });
          }
          quantity?.addEventListener('input', update, { signal: this.controller.signal });
          quantity?.addEventListener('change', update, { signal: this.controller.signal });
          window.addEventListener('resize', update, { signal: this.controller.signal });
          window.addEventListener('scroll', () => {
            if (this.positionFrame) return;
            this.positionFrame = requestAnimationFrame(() => {
              this.positionFrame = null;
              updatePosition();
            });
          }, { passive:true, signal:this.controller.signal });
          update();
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        cancelAnimationFrame(this.positionFrame);
        this.positionFrame = null;
        this.intersection?.disconnect();
        this.mutations?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-purchase-offers"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.pdp-refresh').forEach(root => {
    const updatePurchaseLabels = () => {
      const pricing = root.blissyPurchasePricing;
      if (!pricing) return;
      const threshold = Number(root.querySelector('[data-free-shipping-threshold]')?.dataset.freeShippingThreshold) * 100;
      if (!Number.isFinite(threshold) || threshold <= 0) return;
      const bundle = root.querySelector('.pdp-hero__bundle');
      const bundleQuantity = Number(bundle?.dataset.bundleQuantity || 4);
      const totalFor = quantity => {
        const bundles = bundle ? Math.floor(quantity / bundleQuantity) : 0;
        return bundles * pricing.bundleTotalInCents + (quantity - bundles * bundleQuantity) * pricing.unitPriceInCents;
      };
      const shipping = root.querySelector('[data-pdp-shipping]');
      if (shipping) {
        shipping.style.removeProperty('display');
        shipping.hidden = totalFor(Number(root.querySelector('[data-quantity-input]')?.value) || 1) <= threshold;
      }
      root.querySelectorAll('.pdp-packs__choices label').forEach(label => {
        const quantity = Number(label.querySelector('input')?.value);
        const freeShipping = label.querySelector('[data-pdp-pack-shipping]');
        if (freeShipping) freeShipping.hidden = totalFor(quantity) <= threshold;
        const savings = label.querySelector('.bogosave');
        if (savings) {
          const text = pricing.bundleSavingsPercent + '%';
          if (savings.textContent !== text) savings.textContent = text;
        }
      });
    };
    root.addEventListener('blissy:purchase-pricing', updatePurchaseLabels);
    root.addEventListener('input', event => { if (event.target.matches('[data-quantity-input]')) updatePurchaseLabels(); });
    root.addEventListener('change', event => { if (event.target.matches('[data-quantity-input]')) updatePurchaseLabels(); });
    updatePurchaseLabels();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-scroll-rail"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blissy-scroll-rail')) {
    customElements.define('blissy-scroll-rail', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = {signal: this.controller.signal};
        this.track = this.querySelector('[data-rail-track]');
        if (!this.track) return;
        const behavior = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        const stepSize = () => (this.track.firstElementChild?.getBoundingClientRect().width || this.track.clientWidth) + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
        const controls = this.querySelector('[data-rail-controls]');
        const previous = this.querySelector('[data-rail-step="-1"]');
        const next = this.querySelector('[data-rail-step="1"]');
        const update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          if (controls) controls.hidden = max < 3;
          if (previous) previous.disabled = this.track.scrollLeft < 3;
          if (next) next.disabled = this.track.scrollLeft > max - 3;
        };
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-rail-step]');
          if (!button) return;
          this.track.scrollBy({left: stepSize() * Number(button.dataset.railStep), behavior: behavior()});
        }, options);
        // Touch and trackpad scrolling stay native. Add the same gesture for mouse users.
        let drag = null;
        let suppressClickUntil = 0;
        this.track.addEventListener('dragstart', event => event.preventDefault(), options);
        this.track.addEventListener('click', event => {
          if (Date.now() < suppressClickUntil) { event.preventDefault(); event.stopPropagation(); }
        }, {...options, capture:true});
        this.track.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('input,textarea,select,video,iframe')) return;
          drag = {x:event.clientX, y:event.clientY, left:this.track.scrollLeft, moving:false};
        }, options);
        this.track.addEventListener('pointermove', event => {
          if (!drag) return;
          const dx = event.clientX - drag.x;
          if (!drag.moving && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(event.clientY - drag.y)) {
            drag.moving = true;
            this.track.setPointerCapture(event.pointerId);
            this.track.classList.add('is-dragging');
          }
          if (drag.moving) { event.preventDefault(); this.track.scrollLeft = drag.left - dx; }
        }, options);
        const finish = event => {
          if (!drag) return;
          const moving = drag.moving;
          drag = null;
          this.track.classList.remove('is-dragging');
          if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
          if (moving) {
            suppressClickUntil = Date.now() + 400;
            if (!this.track.hasAttribute('data-rail-free-scroll')) {
              const step = stepSize();
              const destination = Math.round(this.track.scrollLeft / step) * step;
              this.track.scrollTo({left:destination, behavior:behavior()});
            }
          }
        };
        this.track.addEventListener('pointerup', finish, options);
        this.track.addEventListener('pointercancel', finish, options);
        this.track.addEventListener('pointerleave', event => { if (drag && !drag.moving) finish(event); }, options);
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.track.scrollBy({left:stepSize() * (event.key === 'ArrowRight' ? 1 : -1), behavior:behavior()});
        }, options);
        this.track.addEventListener('scroll', update, {...options, passive:true});
        this.observer = new ResizeObserver(() => {
          if (this.resizeFrame) return;
          this.resizeFrame = requestAnimationFrame(() => {
            this.resizeFrame = null;
            update();
          });
        });
        this.observer.observe(this.track);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-section-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blissy-section-nav')) {
    customElements.define('blissy-section-nav', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.nav = this.querySelector('nav');
        this.boundary = this.closest('main');
        if (!this.nav || !this.boundary) return;
        const signal = this.controller.signal;
        this.queue = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
        };
        this.refreshTargets();
        window.addEventListener('scroll', this.queue, { passive:true, signal });
        window.addEventListener('resize', this.queue, { passive:true, signal });
        window.addEventListener('pageshow', this.queue, { signal });
        document.addEventListener('shopify:section:load', () => this.refreshTargets(), { signal });
        document.addEventListener('shopify:section:unload', () => requestAnimationFrame(() => this.refreshTargets()), { signal });
        this.resizeObserver = new ResizeObserver(this.queue);
        this.resizeObserver.observe(this.nav);
        this.resizeObserver.observe(this.boundary);
        this.addEventListener('click', event => {
          const link = event.target.closest('a[href^="#"]');
          if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const target = document.getElementById(link.hash.slice(1));
          if (!target) return;
          event.preventDefault();
          history.pushState(null, '', link.hash);
          target.setAttribute('tabindex', target.getAttribute('tabindex') || '-1');
          target.focus({ preventScroll:true });
          target.scrollIntoView({ block:'start', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal });
        this.queue();
      }
      refreshTargets() {
        this.targets = [...this.nav.querySelectorAll('a[href^="#"]')].map(link => {
          const target = document.getElementById(link.hash.slice(1));
          link.hidden = !target;
          if (target) target.setAttribute('data-pdp-nav-target', '');
          return { link,target };
        }).filter(item => item.target);
        this.hidden = this.targets.length === 0;
        this.queue();
      }
      update() {
        if (!this.isConnected || this.hidden) return;
        const rect = this.getBoundingClientRect();
        const height = this.nav.offsetHeight;
        const end = this.boundary.getBoundingClientRect().bottom;
        const pinned = rect.top <= 0 && end > 0;
        const set = (element,key,value) => { if (element.style.getPropertyValue(key) !== value) element.style.setProperty(key,value); };
        set(this,'--section-nav-height',height+'px');
        set(this.boundary,'--pdp-section-nav-height',height+'px');
        set(this,'--section-nav-left',rect.left+'px');
        set(this,'--section-nav-width',rect.width+'px');
        set(this,'--section-nav-top',Math.min(0,end-height)+'px');
        this.toggleAttribute('data-pinned', pinned);
        let current = null;
        this.targets.forEach(item => { if (item.target.getBoundingClientRect().top <= height+40) current = item; });
        this.targets.forEach(item => {
          if (item === current) item.link.setAttribute('aria-current','location');
          else item.link.removeAttribute('aria-current');
        });
        const activeLink = current?.link || null;
        const navWidth = this.nav.clientWidth;
        if (activeLink && (activeLink !== this.activeLink || navWidth !== this.navWidth)) {
          const navRect = this.nav.getBoundingClientRect();
          const linkRect = activeLink.getBoundingClientRect();
          if (linkRect.left < navRect.left + 10 || linkRect.right > navRect.right - 10) {
            // Scroll only the tab strip, and only on a section/width change, so
            // readers can still swipe through the other navigation links.
            this.nav.scrollTo({
              left:this.nav.scrollLeft + linkRect.left - navRect.left - (navWidth - linkRect.width) / 2,
              behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
            });
          }
        }
        this.activeLink = activeLink;
        this.navWidth = navWidth;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.targets?.forEach(item => item.target.removeAttribute('data-pdp-nav-target'));
        this.boundary?.style.removeProperty('--pdp-section-nav-height');
        this.controller = null;
        this.frame = null;
        this.activeLink = null;
        this.navWidth = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pillow-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    const button = event.target.closest('[data-pillow-hotspot]');
    if (!button) return;
    const detail = document.getElementById(button.dataset.pillowHotspot);
    if (!detail) return;
    detail.open = true;
    button.setAttribute('aria-expanded','true');
    if (matchMedia('(max-width:767px)').matches) detail.scrollIntoView({block:'nearest',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    detail.querySelector('summary')?.focus({preventScroll:true});
  });
  document.querySelectorAll('.pillow-content--construction details').forEach(detail => {
    detail.addEventListener('toggle', () => document.querySelectorAll('[data-pillow-hotspot="'+detail.id+'"]').forEach(button => button.setAttribute('aria-expanded',String(detail.open))));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pillowcase-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blissy-pillowcase-gallery')) {
    customElements.define('blissy-pillowcase-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const track = this.querySelector('.pdp-gallery__track');
        const slides = [...this.querySelectorAll('.pdp-gallery__slide')];
        const thumbs = [...this.querySelectorAll('[data-gallery-index]')];
        const count = this.querySelector('[data-gallery-count]');
        let active = 0;
        let drag = null;
        let suppressClickUntil = 0;
        const goTo = (index) => {
          if (!slides.length) return;
          active = (index + slides.length) % slides.length;
          track.scrollTo({ left: active * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.addEventListener('click', (event) => {
          if (Date.now() < suppressClickUntil) { event.preventDefault(); return; }
          const thumb = event.target.closest('[data-gallery-index]');
          if (thumb) { event.preventDefault(); goTo(Number(thumb.dataset.galleryIndex)); }
          if (event.target.closest('[data-gallery-previous]')) goTo(active - 1);
          if (event.target.closest('[data-gallery-next]')) goTo(active + 1);
        }, options);
        track.addEventListener('dragstart', (event) => event.preventDefault(), options);
        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          drag = { x: event.clientX, y: event.clientY, left: track.scrollLeft, index: active, moving: false };
        }, options);
        track.addEventListener('pointermove', (event) => {
          if (!drag) return;
          const dx = event.clientX - drag.x;
          if (!drag.moving && Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(event.clientY - drag.y)) {
            drag.moving = true;
            track.setPointerCapture(event.pointerId);
            this.classList.add('is-dragging');
          }
          if (drag.moving) {
            event.preventDefault();
            track.scrollLeft = drag.left - dx;
          }
        }, options);
        const finishDrag = (event) => {
          if (!drag) return;
          const dx = event.clientX - drag.x;
          const next = drag.index + (Math.abs(dx) > 40 ? (dx < 0 ? 1 : -1) : 0);
          const moving = drag.moving;
          drag = null;
          this.classList.remove('is-dragging');
          if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
          if (moving) {
            suppressClickUntil = Date.now() + 400;
            goTo(Math.max(0, Math.min(slides.length - 1, next)));
          }
        };
        track.addEventListener('pointerup', finishDrag, options);
        track.addEventListener('pointercancel', finishDrag, options);
        track.addEventListener('pointerleave', (event) => { if (drag && !drag.moving) finishDrag(event); }, options);
        track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            goTo(active + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, options);
        track.addEventListener('scroll', () => {
          const index = Math.round(track.scrollLeft / track.clientWidth);
          if (!slides[index]) return;
          active = index;
          thumbs.forEach((thumb, i) => {
            if (i === active) thumb.setAttribute('aria-current', 'true');
            else thumb.removeAttribute('aria-current');
          });
          if (count) count.textContent = `${active + 1} / ${slides.length}`;
          const thumb = thumbs[active];
          if (thumb) {
            const strip = thumb.parentElement;
            if (thumb.offsetLeft < strip.scrollLeft || thumb.offsetLeft + thumb.offsetWidth > strip.scrollLeft + strip.clientWidth) {
              strip.scrollTo({ left: thumb.offsetLeft - strip.clientWidth / 2 + thumb.offsetWidth / 2 });
            }
          }
        }, { ...options, passive: true });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pillowcase-purchase-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blissy-pillowcase-packs')) {
    customElements.define('blissy-pillowcase-packs', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected || this.controller) return;
          this.controller = new AbortController();
          const options = { signal: this.controller.signal };
          const form = this.closest('form');
          const quantity = form.querySelector('[data-quantity-input]');
          const choices = [...this.querySelectorAll('input[type="radio"]')];
          const syncQuantity = () => choices.forEach(choice => { choice.checked = Number(choice.value) === Number(quantity.value); });
          this.addEventListener('change', event => {
            if (!choices.includes(event.target)) return;
            quantity.value = event.target.value;
            quantity.dispatchEvent(new Event('input', { bubbles: true }));
            quantity.dispatchEvent(new Event('change', { bubbles: true }));
          }, options);
          quantity.addEventListener('input', syncQuantity, options);
          quantity.addEventListener('change', syncQuantity, options);
          syncQuantity();
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pillowcase-story-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blissy-story-video')) {
    customElements.define('blissy-story-video', class extends HTMLElement {
      static metadata = new Map();
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const id = this.dataset.videoId;
        if (!/^[a-z0-9]{10}$/i.test(id)) return;
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          const cache = this.constructor.metadata;
          if (!cache.has(id)) {
            cache.set(id, fetch(`https://fast.wistia.net/oembed?url=https://fast.wistia.net/embed/iframe/${id}&width=960`)
              .then(response => { if (!response.ok) throw new Error('Preview unavailable'); return response.json(); })
              .catch(() => { cache.delete(id); return null; }));
          }
          cache.get(id).then(data => {
            if (!data || !this.isConnected) return;
            const ratio = Number(data.width) / Number(data.height);
            if (Number.isFinite(ratio) && ratio > .2 && ratio < 5) {
              this.dataset.videoRatio = String(ratio);
              this.style.setProperty('--video-ratio', ratio);
            }
            const poster = this.querySelector('[data-video-poster]');
            if (poster && data.thumbnail_url) {
              const url = new URL(data.thumbnail_url);
              if (url.protocol === 'https:') { poster.src = url.href; poster.hidden = false; }
            }
            const duration = this.querySelector('[data-video-duration]');
            if (duration && Number(data.duration) > 0) {
              const seconds = Math.round(Number(data.duration));
              duration.textContent = ` · ${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2,'0')}`;
            }
          }).catch(() => {});
        }, { rootMargin: '250px' });
        this.observer.observe(this);
        this.addEventListener('click', event => {
          const preview = event.target.closest('[data-story-video]');
          if (!preview || !this.hasAttribute('data-inline-player')) return;
          event.preventDefault();
          const player = document.createElement('iframe');
          player.title = preview.dataset.videoTitle;
          player.allow = 'autoplay; fullscreen';
          player.allowFullscreen = true;
          player.src = `https://fast.wistia.net/embed/iframe/${id}?autoPlay=true&videoFoam=true&playerColor=29376e`;
          preview.hidden = true;
          this.append(player);
          player.focus();
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.querySelector('iframe')?.remove();
        const preview = this.querySelector('[data-story-video]');
        if (preview) preview.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pillowcase-story"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blissy-pillowcase-story')) {
    customElements.define('blissy-pillowcase-story', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const dialog = this.querySelector('dialog');
        const player = dialog.querySelector('iframe');
        const videos = this.querySelector('[data-story-videos]');
        const previous = this.querySelector('[data-story-previous]');
        const next = this.querySelector('[data-story-next]');
        const behavior = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        const updateArrows = () => {
          if (!videos) return;
          previous.disabled = videos.scrollLeft <= 2;
          next.disabled = videos.scrollLeft + videos.clientWidth >= videos.scrollWidth - 2;
        };
        this.addEventListener('click', event => {
          const buy = event.target.closest('[data-story-buy]');
          if (buy) {
            const selectors = document.querySelector('.pdp-refresh .selectors');
            if (selectors) { event.preventDefault(); selectors.scrollIntoView({ block: 'center', behavior: behavior() }); }
          }
          if (event.target.closest('[data-story-close]') || event.target === dialog) dialog.close();
          if (videos && (event.target.closest('[data-story-previous]') || event.target.closest('[data-story-next]'))) {
            videos.scrollBy({ left: (event.target.closest('[data-story-next]') ? 1 : -1) * videos.clientWidth, behavior: behavior() });
          }
        }, options);
        document.addEventListener('click', event => {
          const video = event.target.closest('[data-story-video]');
          if (!video || !this.closest('.pdp-refresh')?.contains(video)) return;
          const component = video.closest('[data-video-id]');
          if (component.hasAttribute('data-inline-player')) return;
          const id = component.dataset.videoId;
          if (!/^[a-z0-9]{10}$/i.test(id)) return;
          event.preventDefault();
          dialog.style.setProperty('--video-ratio', component.dataset.videoRatio || '1.77778');
          player.title = video.dataset.videoTitle;
          player.src = `https://fast.wistia.net/embed/iframe/${id}?autoPlay=true&videoFoam=true&playerColor=29376e`;
          dialog.showModal();
        }, options);
        const demo = this.querySelector('[data-demo-video]');
        if (demo) {
          const toggle = this.querySelector('[data-demo-toggle]');
          let userPaused = matchMedia('(prefers-reduced-motion: reduce)').matches;
          const updateToggle = () => { toggle.textContent = demo.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel; };
          demo.addEventListener('play', updateToggle, options);
          demo.addEventListener('pause', updateToggle, options);
          toggle.addEventListener('click', () => {
            userPaused = !demo.paused;
            if (userPaused) demo.pause();
            else demo.play().catch(updateToggle);
          }, options);
          this.demoObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) { demo.pause(); return; }
              if (!demo.dataset.started) { demo.dataset.started = 'true'; demo.load(); }
              if (!userPaused) demo.play().catch(updateToggle);
            });
          }, { threshold: .15 });
          this.demoObserver.observe(demo);
          updateToggle();
        }
        if (videos) {
          let drag = null;
          let suppressClickUntil = 0;
          videos.addEventListener('click', event => {
            if (Date.now() < suppressClickUntil) { event.preventDefault(); event.stopPropagation(); }
          }, { ...options, capture: true });
          videos.addEventListener('dragstart', event => event.preventDefault(), options);
          videos.addEventListener('pointerdown', event => {
            if (event.pointerType !== 'mouse' || event.button !== 0) return;
            drag = { x: event.clientX, y: event.clientY, left: videos.scrollLeft, moving: false };
          }, options);
          videos.addEventListener('pointermove', event => {
            if (!drag) return;
            const dx = event.clientX - drag.x;
            if (!drag.moving && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(event.clientY - drag.y)) {
              drag.moving = true;
              videos.setPointerCapture(event.pointerId);
              videos.classList.add('is-dragging');
            }
            if (drag.moving) { event.preventDefault(); videos.scrollLeft = drag.left - dx; }
          }, options);
          const finishDrag = event => {
            if (!drag) return;
            const moving = drag.moving;
            drag = null;
            const step = videos.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(videos).columnGap);
            const left = Math.round(videos.scrollLeft / step) * step;
            videos.classList.remove('is-dragging');
            if (videos.hasPointerCapture(event.pointerId)) videos.releasePointerCapture(event.pointerId);
            if (moving) { suppressClickUntil = Date.now() + 400; videos.scrollTo({ left, behavior: behavior() }); }
          };
          videos.addEventListener('pointerup', finishDrag, options);
          videos.addEventListener('pointercancel', finishDrag, options);
          videos.addEventListener('pointerleave', event => { if (drag && !drag.moving) finishDrag(event); }, options);
        }
        this.addEventListener('input', event => {
          if (!event.target.matches('[data-story-comparison]')) return;
          event.target.closest('.pdp-hair__comparison').style.setProperty('--comparison-position', `${event.target.value}%`);
        }, options);
        dialog.addEventListener('close', () => player.removeAttribute('src'), options);
        videos?.addEventListener('scroll', updateArrows, { ...options, passive: true });
        window.addEventListener('resize', updateArrows, options);
        updateArrows();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.demoObserver?.disconnect();
        this.querySelector('[data-demo-video]')?.pause();
        this.querySelector('dialog iframe')?.removeAttribute('src');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-review-snippet"] && !Shopify.designMode) return;
  try {
    const syncBlissyReviewSearch = () => {
    document.querySelectorAll('.blissy-reviews[data-search]').forEach(widget => {
      const search = widget.dataset.search;
      if (!search) return;
      const input = widget.querySelector('#stamped-reviews-search-input');
      if (input) input.value = search;
      widget.querySelectorAll('.stamped-reviews-search-clear,.stamped-reviews-filter .stamped-summary-actions-clear').forEach(control => {
        control.style.display = 'block';
      });
    });
  };
  document.addEventListener('stamped:reviews:loaded', () => queueMicrotask(syncBlissyReviewSearch));
  syncBlissyReviewSearch();
  const productReviewWidget = document.querySelector('#stamped-main-widget.blissy-reviews');
  if (productReviewWidget) {
    const syncEmptyReviews = () => {
      const container = productReviewWidget.querySelector('.stamped-container');
      if (!container) return;
      const empty = container.dataset.count === '0';
      const noQuestions = container.querySelector('#tab-questions')?.dataset.count === '0';
      productReviewWidget.classList.toggle('blissy-reviews--empty', empty);
      productReviewWidget.classList.toggle('blissy-reviews--no-questions', empty && noQuestions);
      const header = container.querySelector('.stamped-header');
      const original = container.querySelector('.stamped-empty-state > div');
      let message = container.querySelector('.blissy-review-empty-message');
      if (empty && header && original && !message) {
        message = document.createElement('p');
        message.className = 'blissy-review-empty-message';
        message.textContent = original.textContent.trim();
        header.prepend(message);
      } else if (!empty && message) message.remove();
    };
    document.addEventListener('stamped:reviews:loaded', syncEmptyReviews);
    new MutationObserver(syncEmptyReviews).observe(productReviewWidget, {childList:true,subtree:true});
    syncEmptyReviews();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sleep-mask-travel-option"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blissy-mask-travel-option')) {
    customElements.define('blissy-mask-travel-option', class extends HTMLElement {
      connectedCallback() {
        const selector = document.querySelector('.pdp-mask #blissy-style-selector');
        if (!selector || this.observer) return;
        const sync = () => {
          let grid = selector.querySelector('.blissy-style-grid');
          if (!grid) {
            selector.replaceChildren(this.querySelector('[data-style-fallback]').content.cloneNode(true));
            grid = selector.querySelector('.blissy-style-grid');
          }
          if (!grid.querySelector('[data-mask-travel-link]')) grid.append(this.querySelector('[data-travel-option]').content.cloneNode(true));
          grid.classList.add('blissy-style-grid--travel');
          grid.style.setProperty('--mask-style-columns', Math.min(3, grid.querySelectorAll('a').length));
          selector.style.display = '';
        };
        sync();
        this.observer = new MutationObserver(sync);
        this.observer.observe(selector, {childList:true, subtree:true});
      }
      disconnectedCallback() { this.observer?.disconnect(); this.observer = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
